import styled, { css } from 'styled-components';

import {
planSectionHeight,
trackPaddingSize,
planSectionMinimalWidth,
planContainerWidth,
planContainerHeight,
knobDiameter } from "./constants";

import { PointSectionComponent } from "./PointSection";





export const Selector = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Selector", componentId: "sc-1v2ekgh-0" })(["display:flex;justify-content:center;align-items:center;-webkit-touch-callout:none;user-select:none;-webkit-tap-highlight-color:transparent;"]);








export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1v2ekgh-1" })(["display:flex;position:relative;flex:1 1 auto;"]);





export const KnobContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__KnobContainer", componentId: "sc-1v2ekgh-2" })(["position:absolute;top:-10px;left:0;transition:", ";transition-delay:", ";"],



(props) =>
props.animated ? `transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)` : 'none',
(props) => props.animated ? '.05s' : 'none');






export const Track = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Track", componentId: "sc-1v2ekgh-3" })(["display:flex;overflow:hidden;height:", "px;padding:0 ", "px;box-sizing:border-box;flex:1 0 auto;border-radius:", "px;cursor:pointer;letter-spacing:0.05em;border:2px solid ", ";"],


planSectionHeight,
trackPaddingSize,


planSectionHeight,


({ theme }) => `${theme.colors['Level 1']}`);






export const PointSection = /*#__PURE__*/styled(PointSectionComponent).withConfig({ displayName: "styles__PointSection", componentId: "sc-1v2ekgh-4" })(["flex:1 1 auto;min-width:", "px;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:pointer;user-select:none;mix-blend-mode:normal;&:first-child,&:last-child{flex-grow:1;overflow:", ";justify-content:", ";justify-content:center;}"],

planSectionMinimalWidth,












(props) => props.$isShortVersion ? 'initial' : 'visible',
(props) => props.$isShortVersion ? 'center' : 'unset');











export const Point = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Point", componentId: "sc-1v2ekgh-5" })(["width:", "px;height:", "px;border-radius:50%;display:flex;align-items:center;justify-content:center;overflow:hidden;background-color:", ";&--firstChild{transform:", ";}&--lastChild{transform:", ";}"],
planContainerWidth,
planContainerHeight,





({ hasAccentColors, isDisabled, backgroundColor }) =>
isDisabled ? 'none' : hasAccentColors ? backgroundColor : 'none',


(props) => props.isShortVersion ? 'initial' : 'translateX(-50%)',



(props) => props.isShortVersion ? 'initial' : 'translateX(50%)');









export const TrackValue = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__TrackValue", componentId: "sc-1v2ekgh-6" })(["box-sizing:content-box;text-overflow:ellipsis;overflow:hidden;", ";line-height:18px;text-align:center;color:", ";"],



(props) => css(props.theme.typography.SmallCapsHeadline),


({ hasAccentColors, isDisabled, textColor, theme }) =>
isDisabled ?
theme.colors['Level 2'] :
hasAccentColors ?
textColor :
theme.colors['Level 4']);


export const TrackValuePlus = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__TrackValuePlus", componentId: "sc-1v2ekgh-7" })([""]);








export const Knob = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Knob", componentId: "sc-1v2ekgh-8" })(["display:flex;flex-direction:column;justify-content:center;width:", "px;height:", "px;background-color:", ";border-radius:50%;cursor:pointer;user-select:none;overflow:hidden;transform:", ";box-shadow:", ";&:hover{box-shadow:0px 7px 15px rgba(0,0,0,0.13);}"],



knobDiameter,
knobDiameter,
({ hasAccentColors, isDisabled, backgroundColor, theme }) =>
isDisabled ? '#e0e0e0' : hasAccentColors ? backgroundColor : theme.colors.Background,




(props) => props.isPressed ? 'scale(1)' : 'scale(1.1)',
(props) =>
props.isPressed ? ` 0px 2px 6px rgba(0, 0, 0, 0.13)` : `0px 4px 10px rgba(0, 0, 0, 0.13)`);












export const KnobValue = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__KnobValue", componentId: "sc-1v2ekgh-9" })(["", ";display:flex;margin:0 auto;text-overflow:ellipsis;text-align:center;text-transform:uppercase;color:", ";transition:color 100ms linear;"],
(props) => css(props.theme.typography.Subheadline),





({ hasAccentColors, isDisabled, textColor, theme }) =>
isDisabled ? '#fff' : hasAccentColors ? textColor : theme.colors.Foreground);



export const KnobValuePlus = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__KnobValuePlus", componentId: "sc-1v2ekgh-10" })(["font-size:16px;"]);









export const Label = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Label", componentId: "sc-1v2ekgh-11" })(["display:block;", ";font-size:8px;letter-spacing:0.05em;text-transform:uppercase;font-style:normal;line-height:normal;font-weight:bold;text-align:center;color:", ";transition:color 100ms linear;"],

(props) => css(props.theme.typography.SmallCapsHeadline),







({ hasAccentColors, isDisabled, textColor, theme }) =>
isDisabled ? '#fff' : hasAccentColors ? textColor : theme.colors['Level 4']);